import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";
import { shouldRetryQuery } from "./queries";
import { createSignedInUserSync } from "./signedInUserSync";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      // Long enough to outlast a story read: Back to a list renders it from
      // the cache at once, at full height, so its scroll position restores.
      gcTime: 30 * 60 * 1000,
      retry: shouldRetryQuery,
    },
  },
});

const syncSignedInUser = createSignedInUserSync(queryClient);
onAuthStateChanged(auth, (user) => syncSignedInUser(user?.uid ?? null));

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      {process.env.NODE_ENV === "development" && (
        <ReactQueryDevtools
          initialIsOpen={false}
          buttonPosition={"bottom-right"}
        />
      )}
    </QueryClientProvider>
  </React.StrictMode>,
);
